import { request } from '@/utils/http'
import { UserType } from '@/enums/auth'

/**
 * 菜单权限接口数据结构
 */
export interface MenuPermission {
  /** 唯一标识 */
  id: number
  /** 菜单名称 */
  name: string
  /** 英文名 */
  nameEn: string
  /** 图标 */
  icon?: string
  /** 权限标识 - 对应路由meta.permission */
  permissionCode: string
  /** 状态(0-禁用, 1-启用) */
  status: number
  /** 排序 */
  sort: number
  /** 父节点 */
  parentId: number
  /** 创建人 */
  createdBy?: number
  /** 创建时间 */
  dateCreated?: string
  /** 更新人 */
  modifiedBy?: number
  /** 更新时间 */
  dateModified?: string
}

/**
 * 获取用户菜单权限列表
 * 注意：每次页面刷新都会重新调用此接口，不进行本地持久化
 * @param userType 当前用户类型，默认租户端
 */
export function getMenuPermissions(userType: number = UserType.TENANT): Promise<MenuPermission[]> {
  if (userType === UserType.TENANT) {
    return request.post<MenuPermission[]>('/platform/menu/tenant')
  }
  return request.post<MenuPermission[]>('/enterprise/client/menuPrivilege')
}
